import { Route, Routes } from "react-router-dom";
import { ReportBalanceCashList } from "./list";


export default function ReportBalanceCashRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ReportBalanceCashList />} />
    </Routes>
  );
}
